export default __webpack_public_path__ + "4b7cf782a7bb621abea787edf6ae4a3c.png";